export default __webpack_public_path__ + "static/media/love-duo.23dc457c.jpg";